import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { getCookie } from 'src/app/services/cookies';


@Component({
  selector: 'app-result-payment',
  templateUrl: './result-payment.component.html',
  styleUrls: ['./result-payment.component.scss'],
})
export class ResultPaymentComponent implements OnInit {
  price = '';
  status = '';
  description = '';
  content = '';

  constructor(
    readonly route: ActivatedRoute,
    readonly router: Router,
  ) {
  }

  ngOnInit(): void {
    const url = new URL(window.location.href);
    const queryParams = new URLSearchParams(url.search);

    queryParams.forEach((value, key) => {
      if (key === 'paymentResult[result]') {
        this.status = decodeURIComponent(value);
      }
      if (key === 'paymentResult[amountText]') {
        this.price = decodeURIComponent(value);
      }
      if (key === 'paymentResult[content]') {
        this.content = decodeURIComponent(value);
      }
      if (key === 'paymentResult[description]') {
        this.description = decodeURIComponent(value);
        this.description = this.description.replace(/\\n/g, '');
      }
      console.log(`${key}: ${decodeURIComponent(value)}`);
    });
  }

  handleClick() {
    const a = getCookie('contractNo');
    const b = getCookie('phoneNumber');
    let contractNo, phoneNumber;
    if (a && a !== "null" && a !== "undefined") {
      contractNo = decodeURIComponent(a);
    }
    if (b && b !== "null" && b !== "undefined") {
      phoneNumber = decodeURIComponent(b);
    }
    this.router.navigate(['./swap-wifi-6'], {
      queryParams: {
        contractNo: contractNo,
        phone_nb: phoneNumber,
      },
    });
  }
}
